import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import Admindashboard from "../admin/admindashboard/admindashboard";

import IndexCategory from "../admin/categoryManagement/indexCategory";
import UpdateCategory from "../admin/categoryManagement/updateCategory";
import IndexCourse from "../admin/course/indexCourse";
import UpdateCourse from "../admin/course/updateCourse";
import CourseModule from "../admin/course/courseModule/courseModule";
import UpdateCourseModule from "../admin/course/courseModule/updateCourseModule";
import ContactInformation from "../admin/contactForm/contactInformation";
import CourseOutline from "../admin/course/courseOutline/courseOutline";
import UpdateCourseOutline from "../admin/course/courseOutline/updateCourseOutline";
import CourseExamInformation from "../admin/course/CourseExamInformation/courseExamInformation";
import UpdateCourseExamInformation from "../admin/course/CourseExamInformation/updateCourseExamInformation";
import CourseEnquiry from "../admin/course/CourseEnquiry/courseEnquiry";
import CourseEligibility from "../admin/course/CourseEligibility/courseEligibility";
import BookingDetails from "../admin/bookingDetails/bookingDetails"; // Adjust the path as necessary
import Login from "../admin/loginadmin/login"; // Adjust the path as necessary
import PaymentDetails from "../admin/transactionPayment/transactionPayment";


const AdminNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;
  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Content style={{ background: "#fff" }}>
        <Routes>
          {/* Redirect root (/) to /login if the user is not authenticated */}
          <Route path="/admin" element={<Login />} />

          <Route
            path="/adminDashboard"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <Admindashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCategory"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <IndexCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCategory/updateCategory/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admincourse"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <IndexCourse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admincourse/updateCourse/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateCourse />
              </ProtectedRoute>
            }
          />

          <Route
            path="/adminCourseModule"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CourseModule />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCourseModule/updateCourseModule/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateCourseModule />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminContactMessages"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ContactInformation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCourseOutline"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CourseOutline />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCourseOutline/updateCourseOutline/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateCourseOutline />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCourseExamInformation"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CourseExamInformation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCourseExamInformation/updateCourseExamInformation/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateCourseExamInformation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCourseEnquiry"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CourseEnquiry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCourseEligibility"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CourseEligibility />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminBookingData"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <BookingDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminPaymentData"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <PaymentDetails />
              </ProtectedRoute>
            }
          />

        </Routes>
      </Content>
    </Layout>
  );
};

export default AdminNavigation;
